import { kHasEnabledExternalStorageProviders } from './constants-external-storage'

/**
 * Feature Flags
 *
 * List of feature flags available in the application.
 */
export enum kFeatureFlags {
  /** Fresh Medical Chronology tables demo. */
  /** External document management system connections on Settings. */
  DRIVE_SYNC = 'DRIVE_SYNC',
  /** Manual local testing toggle: show external-storage files and folders in the Matter files drive. */
  DRIVE_SHOW_EXTERNAL_STORAGE_ITEMS = 'DRIVE_SHOW_EXTERNAL_STORAGE_ITEMS',
  /** Templates tab in file-picker/move/select-template modals (not yet supported). */
  TEMPLATES_TAB = 'TEMPLATES_TAB',
  /** Add Template button in the artifact editor toolbar (upload/select a .docx template). */
  ARTIFACT_TEMPLATES = 'ARTIFACT_TEMPLATES',
  /** Userpilot checklist tour card for sample matters on the matter overview page. */
  SAMPLE_MATTER_TOUR = 'SAMPLE_MATTER_TOUR',
  /** Post-signup phone collection before individual users reach Stripe card entry. */
  POST_SIGNUP_PHONE_COLLECTION = 'POST_SIGNUP_PHONE_COLLECTION',
  /**
   * The matter-scoped Drafts destination: its route, sidebar entry, list requests, analytics, and
   * row actions. Existing Matter Overview and chat drafting behavior is unaffected when off.
   */
  DRAFTS_DESTINATION = 'DRAFTS_DESTINATION',
  /**
   * The new sign-in and create-account pages. Build-time rather than a PostHog runtime flag because
   * these pages render for anonymous sessions, which never receive runtime flag values (see
   * docs/architecture/adr/adr-runtime-feature-flags.md).
   */
  ONBOARDING_REFRESH_AUTH_PAGES = 'ONBOARDING_REFRESH_AUTH_PAGES',
}

/**
 * Feature Flag Statuses
 *
 * Defines the enabled/disabled status of each feature flag.
 */
const kFeatureFlagStatus = {
  [kFeatureFlags.DRIVE_SYNC]: kHasEnabledExternalStorageProviders,
  [kFeatureFlags.DRIVE_SHOW_EXTERNAL_STORAGE_ITEMS]: false,
  [kFeatureFlags.ARTIFACT_TEMPLATES]: true,
  [kFeatureFlags.TEMPLATES_TAB]: false,
  [kFeatureFlags.SAMPLE_MATTER_TOUR]: true,
  [kFeatureFlags.POST_SIGNUP_PHONE_COLLECTION]: true,
  [kFeatureFlags.DRAFTS_DESTINATION]: true,
  [kFeatureFlags.ONBOARDING_REFRESH_AUTH_PAGES]: false,
}

/**
 * Get Feature Flag Status
 *
 * Returns the current enabled/disabled status of a given feature flag.
 * Use this in application logic to conditionally enable features.
 *
 * @param flag - The feature flag to check
 * @returns `true` if the feature is enabled, `false` otherwise
 */
export function kGetFeatureFlagStatus(flag: kFeatureFlags): boolean {
  return kFeatureFlagStatus[flag]
}
